var _polygon;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 14 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "chevron_down",
    "data-name": "chevron down",
    points: "0 2 5 7 7 9 9 7 14 2 12 0 7 5 2 0 0 2"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrowDown.31fa9477.svg";
export { ForwardRef as ReactComponent };